import { jwtDecode } from 'jwt-decode'

class JWTUtils {
  decodeToken(token) {
    try {
      const decoded = jwtDecode(token)
      return {
        success: true,
        data: decoded,
      }
    } catch (error) {
      console.error('Erreur décodage token:', error)
      return {
        success: false,
        error: 'Token invalide',
      }
    }
  }

  getShopIdFromToken(token) {
    const decoded = this.decodeToken(token)
    if (decoded.success && decoded.data.shopId) {
      return decoded.data.shopId
    }
    return null
  }

  isTokenExpired(token) {
    const decoded = this.decodeToken(token)
    if (!decoded.success) return true

    const now = Math.floor(Date.now() / 1000)
    return decoded.data.exp < now
  }

  getDaysUntilExpiry(token) {
    const decoded = this.decodeToken(token)
    if (!decoded.success) return 0

    const now = Math.floor(Date.now() / 1000)
    const exp = Math.floor(new Date(decoded.data.planExpiry).getTime() / 1000)

    const remainingSeconds = exp - now

    if (remainingSeconds <= 0) return 0

    return Math.ceil(remainingSeconds / (24 * 60 * 60))
  }

  extractTokenInfo(token) {
    const decoded = this.decodeToken(token)
    if (!decoded.success) return null

    return {
      shopId: decoded.data.shopId,
      email: decoded.data.email,
      plan: decoded.data.plan,
      maxSessions: decoded.data.maxSessions,
      planExpiry: decoded.data.planExpiry,
      issuedAt: decoded.data.iat,
      expiresAt: decoded.data.exp,
      daysUntilExpiry: this.getDaysUntilExpiry(token),
      isExpired: this.isTokenExpired(token),

      // Informations gérant
      managerId: decoded.data.managerId || null,
      managerName: decoded.data.managerName || null,
      role: decoded.data.role || 'owner',
      permissions: decoded.data.permissions || null,
    }
  }

  isPlanExpiringSoon(token, warningDays = 7) {
    const daysLeft = this.getDaysUntilExpiry(token)
    return daysLeft > 0 && daysLeft <= warningDays
  }

  formatPlanExpiry(token) {
    const decoded = this.decodeToken(token)
    if (!decoded.success || !decoded.data.planExpiry) return null

    const date = new Date(decoded.data.planExpiry)
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })
  }
}

export default new JWTUtils()
